import { typedEntries } from '@utils/entries';
import { EmailNotificationsSchema } from './schema';
import type { EmailNotificationStateKeys } from './store';
import { emailNotificationsState } from './store';

export const setField = (name: EmailNotificationStateKeys, value: string, touched?: boolean) => {
  emailNotificationsState.fields[name] = value;
  emailNotificationsState.touched[name] = touched || false;
};

export const setError = (name: EmailNotificationStateKeys, value: string) => {
  emailNotificationsState.errors[name] = value;
};

export const clearEmailNotificationsErrors = () => {
  emailNotificationsState.errors = {
    email: null,
  };
};

export const setAllFieldsTouched = () => {
  emailNotificationsState.touched = {
    email: true,
  };
};

export const setArtistUpdates = (value: boolean) => {
  emailNotificationsState.artistUpdates = value;
};

export const validateEmailNotifications = () => {
  clearEmailNotificationsErrors();

  const result = EmailNotificationsSchema.shape.fields.safeParse(emailNotificationsState.fields);

  if (!result.success) {
    typedEntries(result.error.flatten().fieldErrors).forEach(([key, value]) => {
      emailNotificationsState.errors[key] = value?.[0];
    });
    return;
  }

  return result.data;
};
